import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AccessProvider } from './AccessContext';
import store from './redux/store';
import Login from './pages/login/Login';
import ChangePassword from './pages/login/changePassword';
import Emailupdate from './pages/login/Emailupdate';
import Dashboard from './pages/dashboard/Dashboard';
import Assets from './pages/assetdetails/Assets';
import AssetRegister from './pages/assetdetails/AssetRegister';
import AssetView from './pages/assetdetails/AssetView';
import PpmPlanner from './pages/ppmdetails/ppmplanner';
import ForgotPassword from './pages/login/ForgotPassword';
import ResetPassword from './pages/login/ResetPassword';
import AuthGuard from './pages/login/AuthGuard';
import WorkGroupDetails from './pages/workgroup/WorkGroupDetails';
import WorkGroupRegister from './pages/workgroup/WorkGroupRegister';
import AssetCategoryDetails from './pages/assetcategory/AssetCategoryDetails';
import AssetCategoryRegister from './pages/assetcategory/AssetCategoryRegister';
import AssetTypeCodeDetails from './pages/assettypecode/AssetTypeCodeDetails';
import AssetTypeCodeRegister from './pages/assettypecode/AssetTypeCodeRegister';
import HospitalInformationDetails from './pages/hospitalinformation/HospitalInformationDetails';
import HospitalInformationRegister from './pages/hospitalinformation/HospitalInformationRegister';
import Welcome from './pages/welcome/welcome';
import MaintenanceYear from './pages/maintenanceyear/MaintenanceYear';
import MainLayout from './assets/styled-components/mainLayout';
import PlainLayout from './assets/styled-components/plainLayout';
import CustomRedirect from './components/commoncomponents/CustomRedirect';
import LicenseTypeCodeDetails from './pages/licensetypecode/LicenseTypeCodeDetails';
import LicenseTypeCodeRegister from './pages/licensetypecode/LicenseTypeCodeRegister';
import DocumentSerialNumberRegister from './pages/documentserialnumber/DocumentSerialNumberRegister';
import LicenseCertificateCreatePage from './pages/licensecertificatepage/LicenseCertificateCreatePage';
import LicenseCertificateListPage from './pages/licensecertificatepage/LicenseCertificateListPage';
import UserLocationDetails from './pages/userlocation/UserLocationDetails';
import UserLocationRegister from './pages/userlocation/UserLocationRegister';
import UserDepartmentDetails from './pages/userdepartment/UserDepartmentDetails';
import UserDepartmentRegister from './pages/userdepartment/UserDepartmentRegister';
import Departmentworkrequestlist from './components/departmentworkrequsetcomponents/Departmentworkrequestlist';
import DepartmentworkrequestRegister from './pages/departmentworkrequest/DepartmentworkrequestRegister';
import StandardTaskDetails from './pages/standardtaskdetails/StandardTaskDetails';
import StandardTask from './pages/standardtaskdetails/StandardTask';
import PpmPlannerMain from './components/ppmgeneration/ppmGenerationMain';
import WorkOrderRescheduleMain from './components/workOrderReschedule/workOrderRescheduleMain';
import AssetServiceChangeMain from './components/assetservicechangecomponent/AssetServiceChangeMain'
import CustomThemeProvider from './assets/styled-components/themes/CustomThemeProvider';
import StoreDetailsList from './pages/storedetails/StoreDetailsList';
import StoreDetailsCreate from './pages/storedetails/StoreDetailsCreate';
import AssetConditionListPage from './pages/assetCondition/AssetConditionListPage';
import AssetConditionFormPage from './pages/assetCondition/AssetConditionFormPage';
import WorkOrderreport from './components/reports/filter';
import ItemDetailsList from './pages/itemDetails/ItemDetailsList';
import ItemDetailsRegister from './pages/itemDetails/ItemDetailsRegister';
import VendorDetailsListPage from './pages/vendorDetails/VendorDetailsListPage';
import VendorDetailsFormPage from './pages/vendorDetails/VendorDetailsFormPage';
import StaffDetailsList from './pages/staffdetails/StaffDetailsList';
import { StaffDetailsRegister } from './pages/staffdetails/StaffDetailsRegister';
import StaffDetailsView from './pages/staffdetails/StaffDetailsView';
import Vendordashboard from './pages/vendordashboard/Vendordashboard';
import MaintenanceCalenderPage from './pages/maintenancecalendar/MaintenanceCalendar';
import WorkOrderdetalis from './pages/workorder/Workorderdetails';
import WorkOrderStepper from './components/workordercomponents/WorkOrderStepper';
import TestingCommissiondetalis from './pages/testingcommission/TestingCommissionDetails';
import TestingCommissionRegister from './pages/testingcommission/TestingCommissionRegister';
import ContractManagementListPage from './pages/contractmanagementpage/ContractManagementListPage';
import Appraisalreport from './pages/conditionfilereport/Appraisalreport';
import Filedownload from './pages/conditionfilereport/Filedownload';
import PpmCheckList from './components/ppmchecklistcomponents/PpmCheckList';
import CreatePpmCheckList from './components/ppmchecklistcomponents/CreatePpmCheckList';
import StockRegisterListPage from './pages/stockregister/StockRegisterListPage';
import StockRegisterCreatePage from './pages/stockregister/StockRegisterCreatePage';
import StockRegisterEditPage from './pages/stockregister/StockRegisterEditPage';
import Assetlife from './pages/assetlifereport/Assetlife';
import Fileassetlife from './pages/assetlifereport/Fileassetlife';
import AssetQrCodeList from './pages/assetQrCode/AssetQrCodeList';
import AssetTypeCodeEdit from './pages/assettypecode/AssetTypeCodeEdit';
import AssetTypeCodeView from './pages/assettypecode/AssetTypeCodeView';
import Kpireport from './pages/kpippmreport/Kpireport';
import Kpidownload from './pages/kpippmreport/Kpidownload';
//import EmployeeReportDetails from './pages/employeereport/EmployeeReportDetails';
import FemsDrawingList from './pages/femsdrawing/FemsDrawingList';
import FemsDrawingCreate from './pages/femsdrawing/FemsDrawingCreate';
import Kpirepairview from './pages/kpirepairreport/Kpirepairview';
import Kpirepairfile from './pages/kpirepairreport/Kpirepairfile';
import StaffEfficiencyReport from './pages/employeereport/StaffEfficiencyReport';
import StaffPerformanceReport from './pages/employeereport/StaffPerformanceReport';
import Kpiresponseview from './pages/kpiresponsereport/kpiresponseview';
import Kpiresponsedownload from './pages/kpiresponsereport/kpiresponsedownload';
import StaffDutyRoster from './pages/staffDutyRoster/StaffDutyRoster';
import Contractoutview from './pages/contractreport/Contractoutview';
import Contractoutdownload from './pages/contractreport/Contractoutdownload';
import RoutineInspectionList from './components/routineinspectioncomponents/RoutineInspectionMaintenance';
import RoutineInspectionMain from './components/routineinspectioncomponents/RoutineInspectionMain';
import PredictiveMaintenanceList from './components/predictivemaintenance/PredictiveMaintenance';
import PredictiveMaintenanceMain from './components/predictivemaintenance/PredictiveMaintenanceMain'
import Stockview from './pages/stockreport/Stockview';
import Stockdownload from './pages/stockreport/Stockdownload';
import AssetAnalysis from './pages/reports/assetReport/assetAnalysis';
import Qualitydownload from './pages/qualityreport/Qualitydownload';
import Qualityview from './pages/qualityreport/Qualityview';
import VendorStepperForm from './components/vendorwebform/VendorStepperForm';
import VendorStepper from './components/vendordashboard/VendorStepper';
import Userdeptdashboard from './pages/userDeptdashboard/Userdeptdashboard';
import ScmDetails from './pages/scheduledcorrectivemaintenance/ScmDetails';
import ScmStepper from './components/scmcomponents/ScmStepper';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { defaultLightTheme } from './assets/styled-components/themes/themelist';
import { messaging } from './firebaseConfig';
import { getToken, onMessage } from 'firebase/messaging'; // Import getToken and onMessage
import NotificationHandler from './NotificationHandler';
import { ToastContainer } from 'react-toastify';
import ContractManagementCreatePage from './pages/contractmanagementpage/ContractManagementCreatePage';
import CalibrationCertificateCreates from './pages/calibrationcertificate/CalibrationCertificateCreates';
import CalibrationCertificateLists from './pages/calibrationcertificate/CalibrationCertificateLists'
import RoutineInspectionStepper from './components/routineinspectioncomponents/RoutineInspectionStepper';
import Ppmcalenderview from './pages/ppmcalender/Ppmcalenderview';
import Ppmcalenderdownload from './components/ppmcalenderreportcomponents/Ppmcalenderdownload';
import RoutineInspectionVendorStepperForm from './components/routineInspectionVendorwebform/RoutineInspectionVendorStepperForm';
import RoutineInspectionVendorStepper from './components/vendordashboard/RoutineInspectionVendorStepper';
import SCMVendorStepperForm from './components/scmVendorWebForm/SCMVendorStepperForm';
import VendorLogin from './pages/vendorRegirstration/VendorLogin';
import VendorRegister from './pages/vendorRegirstration/VendorRegister';
import SCMVendorStepper from './components/vendordashboard/SCMVendorStepper';
import ContractEditForm from './components/contractmanagement/ContractEditForm';
import ExpiredPassword from './pages/login/ExpiredPassword';
import PowerBIReport from './components/powerbidashboardcomponents/powerbi';
import Userblocklistpage from './pages/Userblock/Userblocklistpage';
import UserRegistrationForm from './pages/userRegistration/UserRegistrationForm';
import UserRegistrationList from './pages/userRegistration/UserRegistrationList';
import LicenseView from './pages/LicenseReport/LicenseView';
import Licensedownloadform from './components/Licensereportcomponents/Licensedownloadform';
import AssetTransfer from './pages/assetTransfer/AssetTransfer';
import AssetChechInForm from './pages/assetTransfer/AssetChechInForm';
import AssetMedicalRiskManagment from './components/reports/assetMedicalRisk/AssetMedicalRiskManagment';
import BemsAssetMedicalRisk from './components/reports/assetMedicalRisk/BemsAssetMedicalRisk';

function App() {

  // const getFCMToken = async () => {
  //   try {
  //     console.log("to get FCM token");

  //     const token = await getToken(messaging, { vapidKey: "BFUoFlvygg2EGKlvrqB5HRX_Viodmqe3ZumUJQF6vumDTji2lnAcXzdpmNvEi4QS-kXAGyuooNyZmmgg6NYX0qY" });
  //     console.log('FCM Token:', token);
  //     localStorage.setItem('fcmToken', token)
  //     // Send the token to the backend to save it
  //   } catch (error) {
  //     console.error('Error getting token:', error);
  //   }
  // };

  //   // Add a notification to the list
  //   useEffect(() => {
  //     console.log("to get FCM token from useefect");

  //     getFCMToken();
  //     // NotificationHandler.init();
  //   }, [])

  return (
    <Provider store={store}>

      <AccessProvider>
        <CustomThemeProvider>
          <ToastContainer />
          <BrowserRouter>
            <Routes>
              {/* Routes without Sidebar and Header */}
              <Route element={<ThemeProvider theme={{
                ...defaultLightTheme,
                palette: {
                  ...defaultLightTheme.palette,
                },
              }}>
                <CssBaseline /><PlainLayout /></ThemeProvider>}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path='/Expiredchangepassword'>
                  <Route path="" element={<AuthGuard value='Options'><ExpiredPassword /></AuthGuard>} />

                </Route>
                <Route path="/vendorLogin" element={<VendorLogin />} />
                <Route path="/vendorRegistration" element={<VendorRegister />} />
                <Route path="/emailupdate" element={<Emailupdate />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                {/* Catch-all route to handle undefined paths */}
                <Route path="*" element={<CustomRedirect to="/login" />} />
              </Route>
              <Route path='/welcome' element={<ThemeProvider theme={{
                ...defaultLightTheme,
                palette: {
                  ...defaultLightTheme.palette,
                },
              }}><CssBaseline /><Welcome /></ThemeProvider>} />
              <Route element={<PlainLayout />}>
                <Route path="/VendorWorkOrder" element={<VendorStepperForm />} />
                <Route path="/RoutineInspectionVendorWorkOrder" element={<RoutineInspectionVendorStepperForm />} />
                {/* <Route path="/overalldashboard" element={<AuthGuard value=' Overalldashboard'><PowerBIReport /></AuthGuard>} /> */}

                {/* <Route path="/SCMVendorWorkOrder" element={<SCMVendorStepperForm/>} />  */}
              </Route>
              {/* Routes with Sidebar and Header */}

              <Route element={<MainLayout />}>
                <Route path="/dashboard" element={<AuthGuard value='Dashboard'><Dashboard /></AuthGuard>} />
                <Route path="/overalldashboard" element={<AuthGuard value=' Overalldashboard'><PowerBIReport /></AuthGuard>} />
                <Route path="/VendorDashboard" >
                  <Route path="" element={<AuthGuard value='Dashboard'><Vendordashboard /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard><TestingCommissionRegister /></AuthGuard>} />
                  <Route path="edit" element={<AuthGuard><VendorStepper /></AuthGuard>} />
                  <Route path="view" element={<AuthGuard><VendorStepper /></AuthGuard>} />
                  <Route path="routineInspectionWorkOrder" element={<AuthGuard><RoutineInspectionVendorStepper /></AuthGuard>} />
                  <Route path="ViewRIWorkOrder" element={<AuthGuard><RoutineInspectionVendorStepper /></AuthGuard>} />
                  <Route path="SCMWorkOrder" element={<AuthGuard><SCMVendorStepper /></AuthGuard>} />
                  <Route path="ViewSCMWorkorder" element={<AuthGuard><SCMVendorStepper /></AuthGuard>} />

                </Route>
                <Route path="/Userdeptdashboard" element={<AuthGuard value='Dashboard'><Userdeptdashboard /></AuthGuard>} />
              </Route>


              {/* Routes with Sidebar and Header */}
              <Route element={<MainLayout />}>
                <Route path="/dashboard" element={<AuthGuard value='Dashboard'><Dashboard /></AuthGuard>} />
                <Route path="/testingcommission">
                  <Route path="" element={<AuthGuard value='Assets'><TestingCommissiondetalis /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Assets'><TestingCommissionRegister /></AuthGuard>} />
                </Route>
                <Route path="/assetsFEM" >
                  <Route path="" element={<AuthGuard value='Assets'><Assets /></AuthGuard>} />
                  <Route path="registration" element={<AuthGuard value='Assets'><AssetRegister /></AuthGuard>} />
                  <Route path="view" element={<AuthGuard value='Assets'><AssetView /></AuthGuard>} />
                </Route>

                <Route path="/WorkOrderreport" element={<WorkOrderreport />} />
                <Route path="/AssetAnalysisreport" element={<AssetAnalysis />} />

                <Route path="/assetsBEM" >
                  <Route path="" element={<AuthGuard value='Assets'><Assets /></AuthGuard>} />
                  <Route path="registration" element={<AuthGuard value='Assets'><AssetRegister /></AuthGuard>} />
                  <Route path="view" element={<AuthGuard value='Assets'><AssetView /></AuthGuard>} />
                </Route>
                <Route path="/assetmedicalrisk" >
                  <Route path="" element={<AuthGuard value='Assets'><BemsAssetMedicalRisk /></AuthGuard>} />
                </Route>
                <Route path="/ppmplanner" element={<AuthGuard value='Maintenance'><PpmPlanner /></AuthGuard>} />
                <Route path="/hospitalinformation">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><HospitalInformationDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><HospitalInformationRegister /></AuthGuard>} />
                  <Route path="edit" element={<AuthGuard value='Hospital Masters'><HospitalInformationRegister /></AuthGuard>} />
                </Route>
                <Route path="/workgroup">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><WorkGroupDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><WorkGroupRegister /></AuthGuard>} />
                </Route>
                <Route path="/userlocation">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><UserLocationDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><UserLocationRegister /></AuthGuard>} />
                </Route>
                <Route path="/assetcategory">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><AssetCategoryDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><AssetCategoryRegister /></AuthGuard>} />
                </Route>
                <Route path="/assettypecode">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><AssetTypeCodeDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><AssetTypeCodeRegister /></AuthGuard>} />
                  <Route path="edit" element={<AuthGuard value='Hospital Masters'><AssetTypeCodeEdit /></AuthGuard>} />
                  <Route path="view" element={<AuthGuard value='Hospital Masters'><AssetTypeCodeView /></AuthGuard>} />
                </Route>
                <Route path="/maintenanceyear" element={<AuthGuard value='Hospital Masters'><MaintenanceYear /></AuthGuard>} />
                <Route path="/licensetypecode">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><LicenseTypeCodeDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><LicenseTypeCodeRegister /></AuthGuard>} />
                </Route>
                <Route path="/documentserialnumber">
                  <Route path="" element={<AuthGuard value='Options'><DocumentSerialNumberRegister /></AuthGuard>} />

                </Route>
                <Route path="/conditionfilereport">
                  <Route path="" element={<AuthGuard value='Reports'><Appraisalreport /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Filedownload /></AuthGuard>} />
                </Route>

                <Route path="/assetlifecyclereport">
                  <Route path="" element={<AuthGuard value='Reports'><Assetlife /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Fileassetlife /></AuthGuard>} />
                </Route>
                <Route path="/kpippmreport">
                  <Route path="" element={<AuthGuard value='Reports'><Kpireport /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Kpidownload /></AuthGuard>} />
                </Route>
                <Route path="/kpirepairreport">
                  <Route path="" element={<AuthGuard value='Reports'><Kpirepairview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Kpirepairfile /></AuthGuard>} />
                </Route>
                <Route path="/kpiresponsereport">
                  <Route path="" element={<AuthGuard value='Reports'><Kpiresponseview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Kpiresponsedownload /></AuthGuard>} />
                </Route>
                <Route path="/assetcategory">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><AssetCategoryDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><AssetCategoryRegister /></AuthGuard>} />
                </Route>
                <Route path="/contractoutregister">
                  <Route path="" element={<AuthGuard value='Reports'><Contractoutview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Contractoutdownload /></AuthGuard>} />
                </Route>
                <Route path="/licensereport">
                  <Route path="" element={<AuthGuard value='Reports'><LicenseView /></AuthGuard>} />
                 // <Route path="register" element={<AuthGuard value='Reports'><Licensedownloadform /></AuthGuard>} />
                </Route>
                <Route path="/stockanalysis">
                  <Route path="" element={<AuthGuard value='Reports'><Stockview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Stockdownload /></AuthGuard>} />
                </Route>
                <Route path="/qualityimprovement">
                  <Route path="" element={<AuthGuard value='Reports'><Qualityview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Qualitydownload /></AuthGuard>} />
                </Route>
                <Route path="/ppmcalendar">
                  <Route path="" element={<AuthGuard value='Reports'><Ppmcalenderview /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Reports'><Ppmcalenderdownload /></AuthGuard>} />
                </Route>
                <Route path="/callibration">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><CalibrationCertificateLists /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><CalibrationCertificateCreates /></AuthGuard>} />
                </Route>
                <Route path="/stockregister">
                  <Route path="" element={<AuthGuard value='Inventory'><StockRegisterListPage /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Inventory'><StockRegisterCreatePage /></AuthGuard>} />
                  <Route path="edit" element={<AuthGuard value='Inventory'><StockRegisterEditPage /></AuthGuard>} />
                </Route>
                <Route path='/userdepartment'>
                  <Route path="" element={<AuthGuard value='Hospital Masters'><UserDepartmentDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><UserDepartmentRegister /></AuthGuard>} />
                </Route>
                <Route path='/standardtask'  >
                  <Route path='' element={<AuthGuard value='Hospital Masters'><StandardTaskDetails /></AuthGuard>} />
                  <Route path='task' element={<AuthGuard value='Hospital Masters'><StandardTask /></AuthGuard>} />
                </Route>
                <Route path="/maintenancecalendar" element={<AuthGuard value='Calender'><MaintenanceCalenderPage /></AuthGuard>} />
                <Route path="/Departmentworkrequest">
                  <Route path="" element={<AuthGuard value='Maintenance'><Departmentworkrequestlist /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Maintenance'><DepartmentworkrequestRegister /></AuthGuard>} />
                </Route>
                <Route path="/scm" >
                  <Route path="" element={<AuthGuard value='Maintenance'><ScmDetails /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Maintenance'><ScmStepper /></AuthGuard>} />
                </Route>

                <Route path="/ppmgeneration">
                  <Route path="" element={<AuthGuard value='Maintenance'><PpmPlannerMain /></AuthGuard>} />
                </Route>
                <Route path="/assetservicechange">
                  <Route path="" element={<AuthGuard value='Assets'><AssetServiceChangeMain /></AuthGuard>} />
                </Route>

                <Route path="/workOrderReschedule">
                  <Route path="" element={<AuthGuard value='Maintenance'><WorkOrderRescheduleMain /></AuthGuard>} />
                </Route>
                <Route path="/licensecertificate">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><LicenseCertificateListPage /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Hospital Masters'><LicenseCertificateCreatePage /></AuthGuard>} />
                </Route>
                <Route path="/contractmanagement">
                  <Route path="" element={<AuthGuard value='Contract'><ContractManagementListPage /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Contract'><ContractManagementCreatePage /></AuthGuard>} />
                  <Route path="renewalForm" element={<AuthGuard value='Contract'><ContractEditForm /></AuthGuard>} />
                </Route>
                <Route path='/assetqrcode'>
                  <Route path="" element={<AuthGuard value='Assets'><AssetQrCodeList /></AuthGuard>} />
                </Route>
                <Route path="/storedetails">
                  <Route path="" element={<AuthGuard value='Inventory'><StoreDetailsList /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Inventory'><StoreDetailsCreate /></AuthGuard>} />
                </Route>
                <Route path="/femsdrawing">
                  <Route path="" element={<FemsDrawingList />} />
                  <Route path="register" element={<FemsDrawingCreate />} />
                </Route>


                <Route path="/workorder" >
                  <Route path="" element={<AuthGuard value='Maintenance'><WorkOrderdetalis /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Maintenance'><WorkOrderStepper /></AuthGuard>} />
                </Route>

                <Route path="routineInspection" >
                  <Route path="" element={<AuthGuard value='Maintenance'><RoutineInspectionList /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Maintenance'><RoutineInspectionMain /></AuthGuard>} />
                  <Route path="Workorder" element={<AuthGuard value='Maintenance'><RoutineInspectionStepper /></AuthGuard>} />
                </Route>

                <Route path='/assetcondition'>
                  <Route path="" element={<AuthGuard value='Assets'><AssetConditionListPage /></AuthGuard>} />
                  <Route path="form" element={<AuthGuard value='Assets'><AssetConditionFormPage /></AuthGuard>} />
                </Route>

                <Route path="/itemdetails">
                  <Route path="" element={<AuthGuard value='Inventory'><ItemDetailsList /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard value='Inventory'><ItemDetailsRegister /></AuthGuard>} />
                </Route>


                <Route path="/staffperformance" element={<AuthGuard value='Staff'><StaffPerformanceReport /></AuthGuard>} />
                <Route path="/staffefficiency" element={<AuthGuard value='Staff'><StaffEfficiencyReport /></AuthGuard>} />
                <Route path="/staffdutyroster" element={<AuthGuard value='Staff'><StaffDutyRoster /></AuthGuard>} />


                <Route path='/vendordetails'>
                  <Route path="" element={<AuthGuard value='Vendor'><VendorDetailsListPage /></AuthGuard>} />
                  <Route path="form" element={<AuthGuard value='Vendor'><VendorDetailsFormPage /></AuthGuard>} />
                </Route>

                <Route path='/changepassword'>
                  <Route path="" element={<AuthGuard value='Options'><ChangePassword /></AuthGuard>} />

                </Route>

                <Route path='/unblockuser'>
                  <Route path="" element={<AuthGuard value='Options'><Userblocklistpage /></AuthGuard>} />

                </Route>

                <Route path='/assettransfer'>
                  <Route path="" element={<AuthGuard value='Options'><AssetTransfer /></AuthGuard>} />
                </Route>
                <Route path='/assetcehckin'>
                  <Route path="" element={<AuthGuard value='Options'><AssetChechInForm /></AuthGuard>} />
                </Route>

                <Route path='/user'>
                  <Route path="" element={<AuthGuard ><UserRegistrationList /></AuthGuard>} />
                  <Route path="register" element={<AuthGuard ><UserRegistrationForm /></AuthGuard>} />
                  <Route path="edit" element={<AuthGuard ><UserRegistrationForm /></AuthGuard>} />
                  <Route path="view" element={<AuthGuard ><UserRegistrationForm /></AuthGuard>} />
                </Route>


                <Route path='/staffdetails'  >
                  <Route path='' element={<AuthGuard value='Staff'><StaffDetailsList /></AuthGuard>} />
                  <Route path='register' element={<AuthGuard value='Staff'><StaffDetailsRegister /></AuthGuard>} />
                  <Route path='view' element={<AuthGuard value='Staff'><StaffDetailsView /></AuthGuard>} />
                </Route>

                <Route path="/ppmchecklist">
                  <Route path="" element={<AuthGuard value='Hospital Masters'><PpmCheckList /></AuthGuard>} />
                  <Route path='register' element={<AuthGuard value='Hospital Masters'><CreatePpmCheckList /></AuthGuard>} />

                </Route>

                <Route path="/predictiveMaintenance">
                  <Route path="" element={<AuthGuard value='Maintenance'><PredictiveMaintenanceList /></AuthGuard>} />
                  <Route path='register' element={<AuthGuard value='Maintenance'><PredictiveMaintenanceMain /></AuthGuard>} />
                </Route>
                <Route path="/assetmedicalriskreport">
                  <Route path="" element={<AuthGuard value='Reports'><AssetMedicalRiskManagment /></AuthGuard>} />
                </Route>
              </Route>
              <Route path="*" element={<CustomRedirect to="/login" />} />
            </Routes>
          </BrowserRouter>
        </CustomThemeProvider>
      </AccessProvider>
    </Provider>
  );
}

export default App;
